import React, { useRef, useState, useEffect } from "react";
import VolumeControl from "./Volume";
import '../../node_modules/@fortawesome/fontawesome-free/css/all.css';

const TimeLine = ({
    isStudentSelfLearningMode,
    setIsToggle,
    question, setQuestion,
    isToggle,
    videoRef,
    setCurrentQuestionTime, currentQuestionTime,
    setFullStyle,
    isPlaying,
    hitQuestion, setHitQuestion,
    setIsPlaying,
    questions,
    interactiveMode,
    onProgressEvents, setOnProgressEvents,
    onReadyEvents, setOnReadyEvents,
    volume, setVolume,
    mediaLoaded,
    setMediaLoaded,
    setLastHitTime,
    questionStylesInisStudentSelfLearningMode
}) => {
    const progressBarRef = useRef(null);
    const [startPointPosition, setStartPointPosition] = useState(0);
    const [progress, setProgress] = useState(0);
    const [progressTime, setProgressTime] = useState("00:00");
    const [totalDuration, setTotalDuration] = useState("00:00");
    const [videoDuration, setVideoDuration] = useState(0);


    const renderQuestionIndicators = () => {
        return questions.map((question, idx) => {
            const style = {
                left: `${((question.time) / videoDuration) * 100 + startPointPosition}%`,
            };
            if (isStudentSelfLearningMode) {
                // console.log("questionStylesInisStudentSelfLearningMode");
                // console.log(questionStylesInisStudentSelfLearningMode);
                if (questionStylesInisStudentSelfLearningMode.hasOwnProperty(question.id)) {
                    const color = questionStylesInisStudentSelfLearningMode[question.id]?.is_student_answer_correct ? "green" : "red";
                    style.background = color;
                }
            }
            return (
                <span
                    key={idx}
                    data-toggle={interactiveMode ? "tooltip" : ""}
                    title={interactiveMode ? question.questionBody : ""}
                    style={style}
                    className='question-indicator'
                    onClick={() => handleQuestionClick(question)}
                />
            )
        });
    };

    const handleResize = () => {
        const progressBar = progressBarRef.current;
        const rect = progressBar.getBoundingClientRect();
        setStartPointPosition((rect.left / window.innerWidth) - 1);
    };

    const handlePlayPause = () => {
        const video = videoRef.current;
        const duration = video.duration || video.getDuration();
        
        if (video.id == 'video') {
            if (isPlaying) video.pause();
            else video.play();
        }
        setIsPlaying(!isPlaying);
        setHitQuestion(false)

    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60).toString().padStart(2, "0");
        return `${minutes}:${seconds}`;
    };

    const handleQuestionClick = (question) => {
        setQuestion(question);
        setHitQuestion(true);

        const video = videoRef.current;
        setIsPlaying(false);

        if (video.id == 'video') {
            video.pause();
            video.currentTime = question.time;
        } else {
            video.seekTo(question.time);
        }
        setCurrentQuestionTime(question.time);
    }

    const handleProgressBarClick = (event) => {
        if (event.target.tagName == 'SPAN') return;

        const progressBar = progressBarRef.current;
        const progressContainerRect = progressBar.getBoundingClientRect();
        const clickX = event.clientX - progressContainerRect.left;
        const progressBarWidth = progressContainerRect.width;
        const progressPercentage = (clickX / progressBarWidth) * 100;
        const video = videoRef.current;
        const duration = video.duration || video.getDuration();
        const currentTime = (progressPercentage / 100) * duration;

        if (video.id == 'video') video.currentTime = Math.floor(currentTime)
        else video.seekTo(Math.floor(currentTime))
        setProgress(progressPercentage);
        setCurrentQuestionTime(currentTime);
        setHitQuestion(false);
        //setLastHitTime(0)

        // setIsPlaying(true);
        // video.play();
    };


    const toggleActivities = () => {
        if (isToggle) {
            setIsToggle(false);
        } else {
            setIsToggle(true);
        }
    }

    useEffect(() => {
        const video = videoRef.current;

        const handleLoadedMetadata = () => {
            let duration = video.id == 'video' ? video.duration : video.getDuration();
            setTotalDuration(formatTime(duration));
            setVideoDuration(duration)
            setMediaLoaded(true);
        };

        if (video?.id == 'video') {
            video.addEventListener("loadedmetadata", handleLoadedMetadata);
            return () => {
                video.removeEventListener("loadedmetadata", handleLoadedMetadata);
            };
        } else {
            setOnReadyEvents([...onReadyEvents, handleLoadedMetadata])
        }

    }, []);

    useEffect(() => {
        handleResize(); // Initial position calculation


        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const video = videoRef.current;

        if (video?.id == 'video') {
            const handleTimeUpdate = () => {
                const curr = (video.currentTime / video.duration) * 100;
                setProgress(curr);
                setProgressTime(formatTime(video.currentTime))
                if (video.currentTime / video.duration == 1) {
                    setIsPlaying(!setIsPlaying);
                }

            };

            video.addEventListener('timeupdate', handleTimeUpdate);

            return () => {
                video.removeEventListener('timeupdate', handleTimeUpdate);
            };
        } else {
            const handleTimeUpdate = () => {
                // console.log('timeline');

                const curr = (video.getCurrentTime() / video.getDuration()) * 100;
                setProgress(curr);
                setProgressTime(formatTime(video.getCurrentTime()))
                if (video.getCurrentTime() / video.getDuration() == 1) {
                    setIsPlaying(!setIsPlaying);
                }
            }
            !onProgressEvents.some(func => func.toString() == handleTimeUpdate.toString()) &&
                setOnProgressEvents([...onProgressEvents, handleTimeUpdate])
        }

    }, []);
    return (
        <div className={`controls ${!interactiveMode && 'rounded-b-lg'}`} hidden={!mediaLoaded}>
            {interactiveMode && <>
                <span className='interactive-mode'>{`${isToggle ? 'Hide' : 'Show'} Activities`}</span>
                <label className="switch"
                >
                    <input onClick={toggleActivities} type="checkbox" defaultChecked />
                    <span className="slider round"></span>
                </label>
            </>}
            <button className='flex items-center' onClick={handlePlayPause}>
                {isPlaying ?
                    <i
                        className="fa fa-pause play-pause-icon"
                    ></i> :
                    <i
                        className="fa fa-play play-pause-icon"
                    >  </i>
                }
            </button>
            <VolumeControl volume={volume} setVolume={setVolume} videoRef={videoRef} interactiveMode={interactiveMode} />

            <div className="timeline relative"
                ref={progressBarRef}
                onClick={handleProgressBarClick}
            >
                <div className="bar">
                    <div className="inner" style={{ width: `${progress}%` }}></div>
                    {isToggle ?
                        <div className="question-indicators z-10">{renderQuestionIndicators()}</div> : ""}
                </div>
            </div>
            <div className={`progress-time`}>
                {progressTime} / {totalDuration}
            </div>
        </div>

    )
}

export default TimeLine;